import type { ICDFView, Notification } from '@cognite/apm-client';
import type { Filters, Sort } from '@cognite/fdm-client';
import type { ViewReference } from '@cognite/sdk';

import { getCdmViewReferencesFromModelVersion } from '../../providers/fdm-services/cdm-view-reference-utils';

import type { INotificationService } from './notification-service-interface';

export type APMClientDependencies = {
  notifications: Pick<ICDFView<Notification>, 'list'>;
};

const NOTIFICATIONS_SPACE_NOT_SET = 'notifications_space_not_set';

export class NotificationService implements INotificationService {
  private apmClient: APMClientDependencies;
  readonly assetNotificationsCardView: ViewReference;
  readonly instanceSpace: string;
  readonly assetInstanceSpace: string;

  constructor(
    apmClient: APMClientDependencies,
    instanceSpace?: string,
    assetInstanceSpace?: string,
    assetNotificationsCardView?: ViewReference
  ) {
    this.apmClient = apmClient;
    this.instanceSpace = instanceSpace ?? NOTIFICATIONS_SPACE_NOT_SET;
    this.assetInstanceSpace =
      assetInstanceSpace ?? instanceSpace ?? NOTIFICATIONS_SPACE_NOT_SET;
    this.assetNotificationsCardView = {
      ...(assetNotificationsCardView ??
        getCdmViewReferencesFromModelVersion().idmNotification),
      type: 'view',
    };
  }

  async getNotificationDetails(filters: Filters) {
    const {
      items: [notification],
    } = await this.apmClient.notifications.list({ filters });
    return notification;
  }

  async getNotifications(filters?: Filters, sort?: Sort, pageSize = 200) {
    const { items: notifications } = await this.apmClient.notifications.list({
      filters,
      sort,
      pageSize,
      includeNullInDescSort: true,
    });
    return notifications;
  }
}

export const createNotificationService = (
  ...args: ConstructorParameters<typeof NotificationService>
): INotificationService => new NotificationService(...args);
